import TripBookingForm from "./components/TripBookingForm/TripBookingForm";



const App=()=> {
  return (
    <div className="App">
      <TripBookingForm />
    </div>
  );
}

export default App;
